import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import lessWhiteSpace from './less-white-space.svg';
import moreWhiteSpace from './more-white-space.svg';
import { LESS_WHITESPACE, MORE_WHITESPACE } from './constants';
import styles from './CTA.scss';

export default class CTAWhiteSpace extends React.Component {
  static propTypes = {
    input: PropTypes.shape({
      value: PropTypes.any,
      onChange: PropTypes.func.isRequired,
    }),
  };

  onRadioChange = e => this.props.input.onChange(e.target.value);

  render() {
    const { input: { value } } = this.props;

    return (
      <React.Fragment>
        <Form.Group>
          <span className={styles.option}>desktop column spacing</span>
          <Form.Text className={styles.helpBlock}>
            Adjust how snugly you want your call to action items to be positions
            on pages for full width desktop sections.
          </Form.Text>
          <Form.Group>
            <Form.Check
              type="radio"
              checked={value === LESS_WHITESPACE}
              name="whitespace"
              value={LESS_WHITESPACE}
              onChange={this.onRadioChange}
              label="Less white space"
            />
            <img src={lessWhiteSpace} alt="lessnbsp" type="image/svg+xml" width={150} height={150} />
            <Form.Check
              type="radio"
              checked={value === MORE_WHITESPACE}
              name="whitespace"
              value={MORE_WHITESPACE}
              onChange={this.onRadioChange}
              label="More white space"
            />
            <img src={moreWhiteSpace} alt="morenbsp" type="image/svg+xml" width={150} height={150} />
          </Form.Group>
        </Form.Group>
      </React.Fragment>
    );
  }
}
